import { Storage } from '@intelipost-js/secure-providers';

const PageTransactions = () => import('./PageTransactions');

const originMenu = Storage.get('originMenu', 'local') || 'oldmenu';
const pageTitle = originMenu === 'newmenu' ? 'Consulta Pedidos' : 'Transações';

export default {
  path: 'transactions',
  name: 'transactions',
  component: PageTransactions,
  props: route => ({ queryParameters: route.query }),
  meta: {
    title: pageTitle,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions/routes.js